export class UrlHelper {

    /**
     * Extracts the domain of URL.
     * @param {string} url
     * @returns {string}
     */
    static getDomainFromURL(url: string): string {
        // If the url does not start with the protocol it is not a valid URL,
        // and it appends the protocol, so it can be parsed.
        const beginsWithProtocol = new RegExp('^https?:\/\/');
        if (!beginsWithProtocol.test(url)) {
            url = `https://${url}`;
        }
        const parsedURL = new URL(url);

        return parsedURL.host;
    }

    static isSameDomain(urlToCheck: string, currentUrl: string): boolean {
        return UrlHelper.getDomainFromURL(urlToCheck).includes(UrlHelper.getDomainFromURL(currentUrl));
    }
}
